import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

import { IEditNodeDataModel } from "../../entities/edit-node-data-model";
import { modelServices } from "../../scripts/ah.mb.ui.model-services";
import { ModelNotifier } from "../../scripts/model-notifier";

import { HandsontableRenderer } from "../../scripts/ah.mb.ui.HandsontableRenderer";
import { VariableTree } from "../../scripts/ah.mb.ui.variable-tree";
import { bootbox } from "../../infrastructure/bootbox-shim";
import { ClientNotifier, IBasicCommandResponse } from "../../scripts/ah.mb.client-notifications";
import { MessageBox } from "uiv";

interface IRedimNeeded {
    result: "declined" | "redim" | "notneeded";
}

interface INodeVariableInfo {
    name: string;
    description: string;
}

/**
     * Node data editor options interface
     */
interface INodeDataEditorOptions {
    tableContainer: string;
//    variableTreeDiv: string;
}


@Component
export default class EditNodeDataDialog extends Vue {


    @Prop()
    value: IEditNodeDataModel;

    // Model change observer
    private modelObserver = new ModelNotifier();
    private modelServices = new modelServices(this.modelObserver);

    @Prop()
    variableTreeDivId: string;

    @Prop()
    tableDivId: string;

    selectedVariable: INodeVariableInfo = { name:"", description:""}


    private variableTreeBuilder = new VariableTree();
    private userNotifier = new ClientNotifier();
    private tableRenderer: HandsontableRenderer;
    pendingChanges: boolean = false;

//get isPendingChanges() {
    //    return this.pendingChanges;
    //}
    private closeAfterSave = false;

    //data() {
    //    return { pendingChanges: this.pendingChanges };
    //}

    mounted() {
    // Attach button handlers now, not in setup view, because that will cause multiple firing

        this.setupView(this.value.modelId, this.value.nodePathAndName);
        this.valueChanged();

 //   this.valueChanged();
    }

    @Watch("value", { deep: true})
    valueChanged() {

        this.selectedVariable = { name: "", description: "" };

        if (this.value && this.value.modelId && this.value.nodePathAndName) {

            this.pendingChanges = false;
            this.getNodeVariables(this.value.modelId, this.value.nodePathAndName);

        }
    }

    // Gets variable value from server and displays it
    private loadVariableValue(modelId: string, nodePathAndName: string, variableName: string) {

        this.modelServices.getNodeData(modelId, nodePathAndName, variableName)
        .then(data => this.nodeDataReceivedFunc(data, variableName));

    };

    // Node data received handler
    private nodeDataReceivedFunc (data: any, variableName: string) {

        this.tableRenderer.drawTable($(`#${this.tableDivId}`), data, variableName);

        /*{$('#tableDiv').handsontable({
            data: data[0].Value,
            minSpareRows: 0,
            colHeaders: true,
            contextMenu: true
        });*/

        //alert(variableName);

    };

    // Gets currently visible data
    private getCurrentNodeData() {
        const hot = this.tableRenderer.getTable();

        const data = hot.getData(0, 0, hot.countRows() - 1, hot.countCols() - 1);
        return data;
    };

    // Save changes func
    private saveNodeDataChanges(variableName: string, data: any): Promise<IBasicCommandResponse> {

        return this.checkForRedim(variableName)
            .then((needsRedim => {

                if (needsRedim.result === "redim")
                    var notification = this.userNotifier.showBusyNotification(`Saving ${variableName}`);

                return this.modelServices.setNodeData(this.value.modelId,
                    this.value.nodePathAndName,
                    variableName,
                    data)
                    .then(response => {
                        if (needsRedim.result === "redim") {
                            this.userNotifier.clear(notification);
                            bootbox.alert("When redimensioned model is next run, please use cold start.", () => {});
                        }
                        return response;
                    })
                    .then(theResponse => {
                        this.setVariableResponseFunc(theResponse.success, theResponse.response);
                        return theResponse;
                    });
            }));

    };

    // Callback response from set data request
    private setVariableResponseFunc(ok: boolean, response: string) {
        if (ok)
            this.setPendingChanges(false);

        if (ok && this.closeAfterSave)
            this.closeDialog();
    }


    // Shows redim prompt if user has changed dimensions
    private checkForRedim(variableName: string): Promise<IRedimNeeded> {

        if (["NumTimePoints", "NumSubTimePoints", "NumStates", "GlobalModelTimeVector", "SubTimeNames"].findIndex(p => p == variableName) >=0){

            return MessageBox.confirm({
                title: "Edit Node Data",
                content: "Change model dimensions?  This operation can take time to complete in larger models"
            })
                .then
                (() => { // Show "Saving data" notification for this, as it can take a long time to redim

                    // This is now shown by global response handler

                    //this.options.responseDiv
                    //    .html(
                    //        `<div class='alert alert-info node-variable-alert'><em>Saving changes...</em></div>`);

                    //this.options.responseDiv.show(); // removeClass('hide').message('oi');

                    return { result: "redim" };
                })
                .catch(() => {
                    this.setPendingChanges(false);
                    return { result: "declined" };

                });
        } else
            return Promise.resolve<IRedimNeeded>({ result: "notneeded" });


    }

    /**
     * Sets up the dialog
     */
    setupView (modelId: string, nodePathAndName: string) {

        //this.pendingChanges = false;

        // Create the table with no data
        var options: Handsontable.Options =
        {
            data: [],
            contextMenu: true,

            //beforeChange: () => this.setPendingChanges(true),

            afterChange:
                (changes, source) => {
                    // After change handler    
                    if (source !== "loadData")
                        this.setPendingChanges(true);
                },
            copyPaste: true,
            minSpareRows: 0
        }

        this.tableRenderer = new HandsontableRenderer(options);

        // Get the node variables
        //this.getNodeVariables(modelId, nodePathAndName);

    }

    setPendingChanges(value: boolean) {
        this.pendingChanges = value;
    }

    /**
     * Close dialog function
     */
    private closeDialog(){
        this.$emit("closeClicked");
    }

    // Displays available variables
    private displayVariablesFunc(variables) {

        // Build tree with variables
        this.variableTreeBuilder.drawTree(
            variables.nodes,
            false,
            $("#" + this.variableTreeDivId),
//            $( this.viewOptions.variableTreeDiv),
            null, //modelEventsObservable,
            (e, data) => {
                // Node activate handler

                // A DynaTreeNode object is passed to the activation handler
                // Note: we also get this event, if persistence is on, and the page is reloaded.
                //if (node.data.isVariable)


                if (data.node.data.isVariable) {
                    this.selectedVariable = { name: data.node.title, description: data.node.data.description };
                    this.loadVariableValue(this.value.modelId, this.value.nodePathAndName, data.node.title);
                } else
                    this.selectedVariable = { name: "", description: "" };
            
                //$("#diagramHeader").text("Network Diagram - " + nodePath);
                //getDiagramData(node.data.key, nodePath);
            },
            (e, data) => {
                // Node de-activate handler
                // Change of variable - if pending changes, prompt user to save
                //return true;

                if (this.pendingChanges) {
                    // Get this before activate is called, which would mean that getCurrentNodeData would return for the newly selected
                    // node
                    const nodeData = this.getCurrentNodeData();
                    var variableName = data.node.title;

                    bootbox.confirm(`Save changes to ${variableName}?`,
                        (result) => {
                            if (result) {
                                this.saveNodeDataChanges(variableName, nodeData);
                            } else
                                this.setPendingChanges(false);
                        });
                }

            },

            // Selection change handler
            null,
            null
        );


        //varTree.options.keyPathSeparator = '\\';
        //tree.options.onDeactivate = treeNodeDeactivatedHandler;
        //tree.getRoot().activate();

        /*
                var btnGroup = $('#variableButtonGroup');

        variables.forEach(function(n) {
            var $input = $('<input type="button" value="new button" />');
            $input.appendTo(btnGroup);
            
//            alert(n.VariableName);
            }
        );*/
    }


    // Retreive data func
    private getNodeVariables(modelId: string, nodePathAndName: string) {

        this.tableRenderer.clear();

        this.modelServices.getNodeVariables(modelId, nodePathAndName)
            .then(variables => this.displayVariablesFunc(variables));
    }

    closeButtonClick() {
        // Close button click
        // For dialog mode
            if (this.pendingChanges) {

                var variableName = this.variableTreeBuilder.tree.getActiveNode().title;

                bootbox.confirm(`Save changes to ${variableName}?`,
                    (result) => {
                        if (result) {
                            this.closeAfterSave = true;
                            this.saveNodeDataChanges(variableName, this.getCurrentNodeData());
                        }
                        else
                            this.closeDialog();
                    });
            }
            else
                this.closeDialog();

    }

    cancelButtonClick() {

        // Non-modal usage
        if (this.pendingChanges) {
            this.setPendingChanges(false);

            // Reload
            const node = this.variableTreeBuilder.tree.getActiveNode();
            if (node) {

                this.loadVariableValue(this.value.modelId, this.value.nodePathAndName, node.title);
            }

        }

    }

    saveButtonClick() {
        if (this.pendingChanges) {
            this.saveNodeDataChanges(this.variableTreeBuilder.tree.getActiveNode().title, this.getCurrentNodeData());
        }

    }


}



// WEBPACK FOOTER //
// ./ClientApp/components/edit-node-data-dialog/edit-node-data-dialog.ts